import { DisclaimerService } from '@ispm/dashboard/disclaimer-viewer/services/disclaimer.service';
import { DisclaimerViewerComponent } from '@ispm/dashboard/disclaimer-viewer/components/disclaimer-viewer.component';

export const SERVICES = [DisclaimerService];
export const COMPONENTS = [
    // DisclaimerViewerComponent 
];
export const COMPONENTS_EXPORTS = [
    // DisclaimerViewerComponent
];